// Reiter fuer das Translatable-Widget (form/types/translatable.html.twig):
// die Sprachkuerzel werden zu Reitern ueber dem Feld, sichtbar ist nur die
// gewaehlte Sprache. Beim Laden gewinnt die erste Sprache mit Fehler, sonst
// die Standardsprache. Ein Pflichtfeld in einem verdeckten Reiter wuerde die
// Browser-Validierung ins Leere laufen lassen ("not focusable"), deshalb
// oeffnet das invalid-Ereignis den passenden Reiter.
export function mount(host) {
  const tabs = Array.from(host.querySelectorAll('[data-translatable-tab]'));
  const panels = Array.from(host.querySelectorAll('[data-translatable-panel]'));
  if (!tabs.length) {
    return; // Ja/Nein-Variante: alle Sprachen nebeneinander, keine Reiter
  }
  host.classList.add('is-enhanced');

  const activate = (locale) => {
    tabs.forEach((tab) => {
      const on = tab.dataset.translatableTab === locale;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
    });
    panels.forEach((panel) => panel.classList.toggle('is-active', panel.dataset.translatablePanel === locale));
  };

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(tab.dataset.translatableTab));
    tab.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
        return;
      }
      event.preventDefault();
      const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      activate(next.dataset.translatableTab);
      next.focus();
    });
  });

  // Gefuellt/leer am Reiter markieren, damit man sieht, welche Sprache fehlt.
  panels.forEach((panel) => {
    const tab = tabs.find((t) => t.dataset.translatableTab === panel.dataset.translatablePanel);
    const field = panel.querySelector('input, textarea, select');
    if (!tab || !field) {
      return;
    }
    const sync = () => tab.classList.toggle('is-filled', field.value.trim() !== '');
    field.addEventListener('input', sync);
    panel.addEventListener('trix-change', sync);
    sync();
  });

  const form = host.closest('form');
  if (form) {
    form.addEventListener('invalid', (event) => {
      const panel = event.target.closest('[data-translatable-panel]');
      if (panel && panel.closest('[data-translatable]') === host) {
        activate(panel.dataset.translatablePanel);
      }
    }, true);
  }

  const initial = tabs.find((t) => t.classList.contains('is-invalid'))
    || tabs.find((t) => t.dataset.translatableTab === host.dataset.defaultLocale)
    || tabs[0];
  activate(initial.dataset.translatableTab);
}
